
export function GerarChavePedido(codCliente) {
    let data = new Date().getTime();
    let valor = data.toString().substring(4, data.length);
    let aleatorio = (Math.random() * 10).toString();
    let aux = aleatorio.replace(".", "").substring(0, 11);
    let chave = codCliente + valor + aux;
    chave = chave.substring(0, 13);
    return chave;
}